import { Box, Button, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {
   approveRejectPG,
   getCustomerGroups,
   getProductGroups,
   setState,
} from "./cgpgSlice";
import moment from "moment";

// #region getProductGroupsCol function
function getProductGroupsCol() {
   const width = 200;
   return [
      { field: "productGroupName", headerName: "Group Name", width: width },
      { field: "countryCode", headerName: "Country Code", width: width },
      { field: "status", headerName: "Status", width: width },
      { field: "updatedDate", headerName: "Last Action Date", width: width, valueFormatter: (params) =>moment(params.value).format('DD/MM/YYYY') },
      { field: "updatedBy", headerName: "Last Action By", width: width },
      {
         field: "reject",
         headerName: "Reject",
         widht: width,
         renderCell: RejectButton,
      },
      {
         field: "approve",
         headerName: "Approve",
         widht: width,
         renderCell: ApproveButton,
      },
      {
         field: "edit",
         headerName: "Edit",
         widht: width,
         renderCell: EditButton,
      },
   ];
}
// #endregion

// #region Product Groups Table
export default function ProductGroupsTable() {
   const dispatch = useDispatch();
   const states = useSelector((store) => store.cgpgApproval);
   const { productGroupsTable, selectedRows } = states;
   const { rows } = productGroupsTable;
   const columns = getProductGroupsCol();

   const [paginationModel, setPaginationModel] = useState({
      pageSize: 20,
      page: 0,
   });

   return (
      <Box sx={{ mt: 3 }}>
         <DataGrid
            rows={rows}
            columns={columns}
            onRowSelectionModelChange={(selRows) => {
               dispatch(setState("selectedRows", selRows));
            }}
            rowSelectionModel={selectedRows}
            checkboxSelection
            disableColumnMenu
            disableRowSelectionOnClick
            paginationMode={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[20, 50, 100]}
         />
      </Box>
   );
}
// #endregion

// #region Reject Button
function RejectButton(params) {
   const dispatch = useDispatch();
   const states = useSelector((store) => store.cgpgApproval);
   const {
      productGroups,
      selectedCountryID,
      selectedGroupStatus,
      selectedPeriod,
      selectedView,
   } = states;

   function search() {
      dispatch(setState("productGroupsTable", null));
      dispatch(setState("customerGroupsTable", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("selectedRows", []));

      const obj = {
         logedUser: JSON.parse(localStorage.getItem("data")),
         countryId: selectedCountryID,
         groupStatus: selectedGroupStatus,
         period: selectedPeriod,
         searchText: "",
      };

      if (selectedView === "Product Group") {
         dispatch(getProductGroups(obj));
      } else {
         dispatch(getCustomerGroups(obj));
      }
   }

   function reject() {
      const id = params.row.id;
      const productGroup = productGroups.find((pg) => pg.productGroupID === id);
      const obj = {
         ...productGroup,
         isApprove: 0,
      };
      console.log("Approval_CGPG_RejectPG", obj);
      dispatch(approveRejectPG(obj));
      search();
   }

   if (params.row.status.includes("Submitted")) {
      return (
         <IconButton onClick={reject}>
            <CancelIcon sx={{ color: "red.main" }} />
         </IconButton>
      );
   }
   return null;
}
// #endregion

// #region Approve Button
function ApproveButton(params) {
   const dispatch = useDispatch();
   const states = useSelector((store) => store.cgpgApproval);
   const {
      productGroups,
      selectedCountryID,
      selectedGroupStatus,
      selectedPeriod,
      selectedView,
   } = states;

   function search() {
      dispatch(setState("productGroupsTable", null));
      dispatch(setState("customerGroupsTable", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("selectedRows", []));

      const obj = {
         logedUser: JSON.parse(localStorage.getItem("data")),
         countryId: selectedCountryID,
         groupStatus: selectedGroupStatus,
         period: selectedPeriod,
         searchText: "",
      };

      if (selectedView === "Product Group") {
         dispatch(getProductGroups(obj));
      } else {
         dispatch(getCustomerGroups(obj));
      }
   }

   function approve() {
      const id = params.row.id;
      const productGroup = productGroups.find((pg) => pg.productGroupID === id);
      const obj = {
         ...productGroup,
         isApprove: 1,
      };
      console.log("Approval_CGPG_ApprovePG", obj);
      dispatch(approveRejectPG(obj));
      search();
   }

   if (params.row.status.includes("Submitted")) {
      return (
         <IconButton onClick={approve}>
            <CheckCircleIcon sx={{ color: "green.main" }} />
         </IconButton>
      );
   }
   return null;
}
//#endregion

// #region Edit Button
function EditButton(params) {
   return (
      <IconButton>
         <EditNoteIcon sx={{ color: "blue.main" }} />
      </IconButton>
   );
}
//#endregion

// reject post call payload
// const obj = {
//    "countryID": 172,
//    "countryName": "Germany",
//    "countryCode": "DE",
//    "countrySalesOrganizationCode": "Europe & Canada",
//    "productGroupID": 30000059,
//    "selectedCustomerID": null,
//    "productGroupName": "PG 20230810 1222",
//    "productGroupCode": null,
//    "comments": "Testing Reject",
//    "effectiveStartDate": "2024-01-04",
//    "effectiveEndDate": "0001-01-01T00:00:00",
//    "sentToSAP": null,
//    "status": "Submitted – Approved and Modified",
//    "previousGroupID": 0,
//    "email": null,
//    "files": [],
//    "type": null,
//    "sapGrpCode": null,
//    "filePaths": null,
//    "updatedBy": "qmsadmin@iqvia.com",
//    "updatedDate": "2023-10-21T05:44:03.217",
//    "products": null,
//    "productGroupList": null,
//    "productGroupFiles": null,
//    "activeInScenarios": 0,
//    "tranOptions": {
//        "timeout": "00:05:00",
//        "isolationLevel": 3
//    },
//    "state": false,
//    "canApproveReject": true,
//    "canEdit": false,
//    "isApprove": 0,
//    "userRole": "Administrator"
// }

//approve post call payload
// {
//    "countryID": 172,
//    "countryName": "Germany",
//    "countryCode": "DE",
//    "countrySalesOrganizationCode": "Europe & Canada",
//    "productGroupID": 30000063,
//    "selectedCustomerID": null,
//    "productGroupName": "PG 20231023 1634",
//    "productGroupCode": null,
//    "comments": "TEST PG 20231023 1634",
//    "effectiveStartDate": "2024-01-04",
//    "effectiveEndDate": "0001-01-01T00:00:00",
//    "sentToSAP": null,
//    "status": "Submitted",
//    "previousGroupID": 0,
//    "email": null,
//    "files": null,
//    "type": null,
//    "sapGrpCode": null,
//    "filePaths": null,
//    "updatedBy": "qmsadmin@iqvia.com",
//    "updatedDate": "2023-10-23T10:36:15.733",
//    "products": null,
//    "productGroupList": null,
//    "productGroupFiles": null,
//    "activeInScenarios": 0,
//    "tranOptions": {
//        "timeout": "00:05:00",
//        "isolationLevel": 3
//    },
//    "state": false,
//    "canApproveReject": true,
//    "canEdit": false,
//    "isApprove": 1,
//    "userRole": "Administrator"
// }
